import * as React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Box, Typography, InputLabel } from "@material-ui/core";
import { useTranslation } from "react-i18next";

type Props = {
  name: string;
  value: string;
  form: any;
};

export default function Text(props: Props) {
  const { name, form, value } = props;
  const { t } = useTranslation();

  return (
    <>
      <Box color="text.primary">
        <Typography>{t(name)}</Typography>
      </Box>
      <Box color="text.primary">
        <Typography variant="subtitle1">{value}</Typography>
      </Box>
      <input name={name} type="hidden" ref={form.register} />
    </>
  );
}
